import { Link } from "react-router-dom";

export default function AcceptTerms({ checked, onChange, testId = "accept-terms" }) {
  return (
    <label className="flex items-start gap-3 text-sm text-[var(--text-2)] cursor-pointer select-none">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required
        className="mt-1 h-4 w-4 shrink-0 accent-[var(--red)] cursor-pointer"
        data-testid={testId}
      />
      <span>
        I have read, acknowledge, and agree to the{" "}
        <Link to="/compliance#privacy" target="_blank" className="link-red">Privacy Statement</Link>{" "}
        and{" "}
        <Link to="/compliance#terms" target="_blank" className="link-red">Terms of Use</Link>.
      </span>
    </label>
  );
}
